<script setup lang="ts">
import type { PortableTextMarkComponentProps } from "@portabletext/vue";
import { computed} from 'vue';

defineOptions({
  inheritAttrs: false,
});

const props = defineProps<
  PortableTextMarkComponentProps<{
    // Keys come in under props.value
    _key: string;
    _type: string;
    anchor?: string;
  }>
>();

const handleAnchor = computed(() => props.value?.anchor && props.value.anchor.startsWith('#') ? props.value.anchor : `#${props.value?.anchor}`);
</script>

<template>
  <NuxtLink v-if="props.value?.anchor" :to="{ hash: handleAnchor }">
    <slot />
  </NuxtLink>
</template>
